import { md5 } from '@roai/shared';

export async function getAudioFingerprint(): Promise<string> {
  // 1. 检测浏览器支持
  const AudioContext = window.OfflineAudioContext;
  if (!AudioContext) {
    return 'unsupported';
  }

  // 2. 创建离线音频上下文（避免用户听到声音）
  const context = new AudioContext(1, 44100, 44100); // 1通道, 采样率44100Hz, 缓冲区44100样本（1秒）
  const oscillator = context.createOscillator();
  const compressor = context.createDynamicsCompressor();
  const gainNode = context.createGain();

  // 3. 配置音频节点
  oscillator.type = 'triangle';
  oscillator.frequency.setValueAtTime(10000, 0); // 10kHz 高频
  gainNode.gain.setValueAtTime(0.5, 0); // 避免 clipping
  compressor.threshold.setValueAtTime(-50, 0);
  compressor.ratio.setValueAtTime(12, 0);

  // 4. 连接音频处理链
  oscillator.connect(gainNode);
  gainNode.connect(compressor);
  compressor.connect(context.destination);

  // 5. 渲染音频数据
  oscillator.start();
  const audioBuffer = await context.startRendering();
  oscillator.stop();

  // 6. 提取音频数据并计算哈希
  const channelData = audioBuffer.getChannelData(0); // 获取左声道数据
  let hash = 0;
  for (let i = 0; i < channelData.length; i++) {
    hash = (hash << 5) - hash + channelData[i] * 1000; // 放大数据避免小数位丢失
    hash |= 0; // 强制转换为32位整数
  }

  return md5(Math.abs(hash).toString(16)).toString(); // 返回16进制哈希
}
